/* eslint-disable max-len */
export const tooltipMessages = {
    'Tooltips.account.dormantStatus':
        'Dormant Accounts are accounts which haven’t had a detected log-in event for greater than 45 days across any SaaS application.',
    'Tooltips.account.personal': 'Personal Account',
    'Tooltips.account.service': 'Service Account',
    'Tooltips.account.shared': 'Shared Account',
    'Tooltips.account.work': 'Work Account',
    'Tooltips.activity_disabled':
        'Activity Collection has been disabled on this client.',
    'Tooltips.alert.delete': 'Delete Alert',
    'Tooltips.alert.set_as_default':
        'If checked, this alert will be added to all existing clients and new clients that are created.',
    'Tooltips.alerts.managed_by_partner':
        'This rule has been created by your partner and cannot be edited.',
    'Tooltips.app_users':
        'Application users are determined when a user utilizes an application for a certain period of time, or authenticates into the application.',
    'Tooltips.application':
        'An application can be either a web or desktop based or both. All usage and settings are aggregated under a single application.',
    'Tooltips.applications.ssoBreakdown':
        'The totals shown on this graph only include applications that we’ve detected that support SSO usage and in most cases does not include desktop or personal applications. Selecting either option will take you to the Unclassified application view.',
    'Tooltips.Badge.google_sso':
        'App found via Browser Extensions with Google SSO',
    'Tooltips.Badge.microsoft_sso':
        'App found via Browser Extensions with Microsoft SSO',
    'Tooltips.Badge.quickScanLogin': 'App found via Browser History',
    'Tooltips.bulk_edit_all_apps':
        'Select all apps on the page so that they can be edited in bulk.',
    'Tooltips.business_owner':
        'A business owner is the organizations single point of contact for the application.',
    'Tooltips.classified_description':
        'Classified applications are apps that have either a lifecycle stage or a business owner set.',
    'Tooltips.Clients.learning_mode':
        'This client was deployed within the last 30 days. You may see fewer apps than expected until the platform learns existing user tendencies and collects app data during its initial assessment.',
    'Tooltips.Clients.misconfigured':
        'The deployment was not able to detect the client name or the client ID from the RMM, please check the configuration and click here to try again.',
    'Tooltips.Clients.no_domains':
        'This client does not have a domain name configured. We use this to determine which apps may be personal or work related. You can add one or multiple client domain names by clicking here or navigating to Utilities > Domain Configuration within this client’s Auvik SaaS Management tenant.',
    'Tooltips.Clients.removedFromPanel':
        'This client has been removed from the visible panel.',
    'Tooltips.Common.partner_token':
        'This Partner Token is used for deploying Auvik SaaS Management to any customer.',
    'Tooltips.contract_management_alerting':
        'Enable alerting if you would like to be informed before a contract comes due.',
    'Tooltips.contract_management_alerting_days':
        'Set the amount of days before the monthly renewing date you would like an alert to come to the business owners inbox.',
    'Tooltips.contract_management_alerting_monthly':
        'If you would like to enable alerting select this option. You can configure when you would like to set up alerts below.',
    'Tooltips.contract_management_alerting_renew':
        'If you would like to enable alerting select this option. You will receive alerts 90 days, 60 days, 30 days, 14 days, 7 days, 5 days, and 1 day before the renewal date.',
    'Tooltips.contract_management_enabled':
        'Enabling Contract Management for this application will allow you to set up alerts and store details about your agreement with this software.',
    'Tooltips.contract_management_monthly_renewal_date':
        'If this contract is renewed month over month, set the day in which you are billed on the cycle.',
    'Tooltips.contract_management_mrr':
        'Monthly-Recurring Charges on the contract.',
    'Tooltips.contract_management_notes':
        'Enter additional notes for the contract here.',
    'Tooltips.contract_management_nrc':
        'Non-Recurring Charges on the contract.',
    'Tooltips.contract_management_renew_renewal_date':
        'If this contract is renewed once a year or on a non-standard monthly period, set the next date in which you are billed.',
    'Tooltips.contract_management_tcv':
        'Total Contract Value for the contract.',
    'Tooltips.contract_management_users':
        'How many users were subscribed for this contract?',
    'Tooltips.copy_client_id': 'Client ID of the organization. Click to copy.',
    'Tooltips.default_permission_new_nonstandard_user':
        'The default permission is used when users are created outside of the standard invitation process, such as navigating from other products.',
    'Tooltips.delete_device': 'Delete Device',
    'Tooltips.Deployment.token':
        'This Client Token is used for deploying Auvik SaaS Management to a specific customer.',
    'Tooltips.disableUser': 'Disable User',
    'Tooltips.domain_managed':
        'If the signed in user is not Domain Managed, and a User Principal Name (UPN) cannot be detected, we are unable to map them to Microsoft Entra ID and they will report as the device instead.',
    'Tooltips.domains_comma_separated':
        'Enter the the client’s domain name(s). If using more than one primary domain, separate them with a comma. This information is used to more accurately identify apps as they are discovered.',
    'Tooltips.enableAuvikSupportAccessWarning':
        'Warning: Disabling this revokes remote access for Auvik Support team - this will need to be enabled if you need a support team member to access your instance to troubleshoot an issue.',
    'Tooltips.enableUser': 'Enable User',
    'Tooltips.exportFunctionality.disabled':
        'Export functionality is exclusive to our full product versions and isn’t available during the trial.',
    'Tooltips.exportFunctionality.disabled_max_rows':
        'Too many records. Please change the filters to narrow your search.',
    'Tooltips.google_enabled':
        'This organization is integrated with Google Workspace.',
    'Tooltips.Insights.service_creds':
        "Credentials containing service emails such as 'administrator@company.com'  or 'support@company.com'.",
    'Tooltips.Insights.shared_creds':
        'Credentials found to be shared between employees.',
    'Tooltips.Insights.total_apps':
        'Total Apps Discovered shows all classified, unclassified, and personal apps.',
    'Tooltips.Insights.vendor_incidents':
        'Vendor Incidents discovered in apps that your employees are using.',
    'Tooltips.License.TotalNumberOfUnderutilizedLicenses':
        'Accounts where the last-login data provided by the integration is greater than 30 days.',
    'Tooltips.License.UndetectedAccounts':
        'Accounts without ASM user activity detected from browser extension or agent.',
    'Tooltips.lifecycle_stage':
        'A lifecycle stage represents where the application is in the application lifecycle. Starting at Implementing and ending at Decommissioned.',
    'Tooltips.Logs.genericCred':
        'Identifies service credentials that are often shared between employees or department members such as support@example.com or administrator@example.com',
    'Tooltips.Logs.incident_flags':
        'Incident flags are marked on user activity that does not meet common security best practices.',
    'Tooltips.Logs.personalCred':
        'Identifies personal credentials being used on work devices such as a personal gmail or hotmail account.',
    'Tooltips.Logs.sharedCred':
        'Identifies credentials & accounts that are being shared between multiple users.',
    'Tooltips.management_state':
        'This represents the state of the application. A Managed Application has a Business Owner and a Lifecycle Stage other than Discovered assigned to it. Otherwise the application is considered to be Unmanaged.',
    'Tooltips.microsoftEntraID.enabled':
        'This organization is integrated with Microsoft Entra ID.',
    'Tooltips.noIdentityManagerIntegration':
        'No identity manager integration detected - click here to configure one.',
    'Tooltips.Notes.input_actions':
        'Mark as Complete, this will hide the note and remove it from reporting.',
    'Tooltips.Notes.mark_as_complete': 'Mark as Complete',
    'Tooltips.Notes.type': 'The category of the note you’d like to add.',
    'Tooltips.orglist.active_user_count':
        'An active user has had application activity within the past 30 days.',
    'Tooltips.orglist.applications':
        'Total Applications in the Organization. The Progress bar indicators how many applications are classified versus unclassified.',
    'Tooltips.orglist.deviceCount':
        'Number of Active devices for this particular deployment.',
    'Tooltips.orglist.organizationIds':
        'Organization Name is the name in the User Interface that is provided. The ClientID is the internal ID provided by the Deployment Software.',
    'Tooltips.orglist.status': 'The status of integration for the client.',
    'Tooltips.orglist.unclassified_applications':
        'Applications that are unclassified should be remediated.',
    'Tooltips.owner.managed3rdParty':
        'Your organization does not manage this application on behalf of the customer, the customer does not manage it, and a third party group is in charge of management.',
    'Tooltips.owner.managedByPartner':
        'Your organization manages this application on behalf of the customer/site. These are applications you support across the entire base.',
    'Tooltips.owner.noBusinessOwnerRequired':
        'No one manages it or it is a self-managed application by the employees using the resources (such as a web portal, etc.)',
    'Tooltips.provider.excludeGroup':
        'Excludes users from data collection activity. If users in this group already exist, they will be disabled.',
    'Tooltips.provider.includeGroup':
        'Removes this group from excluded list. Users within this group will be imported during the next Identity Manager sync.',
    'Tooltips.rank':
        'An applications rank is based on how much usage was used over the last 90 days relative to all managed and un-managed applications. Application rank is updated nightly.',
    'Tooltips.renewalDate': 'This date is when the contract renews.',
    'Tooltips.Reports.expandUserDetails':
        'Adds individual user details to the report under each discovered app. Sorted by usage.',
    'Tooltips.resend_invitation': 'Resend Invitation',
    'Tooltips.revoke_invitation': 'Revoke Invitation',
    'Tooltips.risk':
        'Risk is determined by the application’s category as well as its likelihood of containing sensitive data. Risk level can be modified.',
    'Tooltips.showHideColumns': 'Show/Hide columns',
    'Tooltips.unanalyzedApplications':
        'Applications that lack category or description data. These could be niche, newly discovered, or unconsolidated app versions. Monitoring is fully supported, but curated details like risk or category may be unavailable.',
    'Tooltips.unclassified_source':
        'The unclassified source is dependent on whether the application was found on the desktop agent or the browser extension agent. Some applications can be found from both.',
    'Tooltips.usage_chart':
        'This Usage Chart represents the last 20 weeks of usage, week over week growth compared to the most used applications in the organization.',
    'Tooltips.user_tracking_warning':
        'Warning: Disabling this option may reduce the quality of your user experience as it prevents you from accessing user guides and in-app configuration tips.',
    'Tooltips.Users.exclude_disabled':
        'Disabled Users are users who have been manually removed from Auvik SaaS Management or disabled in a linked Identity manager like Active Directory.',
    'Tooltips.Users.exclude_expired':
        'Expired Users are users who are no longer actively submitting data. This can happen when a device goes offline for an extended period or when Auvik SaaS Management identifies the user and submits it under another entry.',
    'Tooltips.Users.expired':
        'Active SaaS Management users who have previously logged in to this application with this account.',
    'Tooltips.Webhooks.delete': 'Delete Webhook',
    'Tooltips.work_usage':
        'This is the percentage of log-ins that used a company domain - Apps that do not capture login data, such as a desktop app, will not show any data.',
    'Tooltips.zeroDevicesTenantWarning':
        'This tenant has no SaaS agents deployed. Get full SaaS Insights by deploying the ASM Agent and Browser Extensions.',
    'Tooltips.zeroDevicesWarning':
        'Critical business data is missing from your environment! Deploy the ASM Agent and Browser Extensions for Full SaaS Visibility.'
};
